export const userActions = { disable: "disable", impersonate: "impersonate" };
